var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.375 3.5H0.625M12.1248 5.375L11.7797 10.55C11.647 12.5405 11.581 13.5358 10.9323 14.1425C10.2835 14.75 9.28525 14.75 7.29025 14.75H6.70975C4.71475 14.75 3.7165 14.75 3.06775 14.1425C2.419 13.5358 2.35225 12.5405 2.22025 10.55L1.87525 5.375",
    stroke: "#E65E5E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.875 3.5H2.9575C3.25933 3.49229 3.55182 3.39367 3.79669 3.21703C4.04157 3.0404 4.22744 2.79398 4.33 2.51L4.3555 2.43275L4.42825 2.2145C4.4905 2.02775 4.522 1.93475 4.56325 1.85525C4.64441 1.69954 4.76088 1.56499 4.90336 1.46237C5.04583 1.35974 5.21035 1.2919 5.38375 1.26425C5.4715 1.25 5.56975 1.25 5.76625 1.25H8.23375C8.43025 1.25 8.5285 1.25 8.61625 1.26425C8.78965 1.2919 8.95417 1.35974 9.09664 1.46237C9.23912 1.56499 9.35559 1.69954 9.43675 1.85525C9.478 1.93475 9.5095 2.02775 9.57175 2.2145L9.6445 2.43275C9.73955 2.7487 9.93611 3.02451 10.2038 3.21745C10.4714 3.41039 10.7952 3.5097 11.125 3.5",
    stroke: "#E65E5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c833a97c84f21b42471385b19b95cfc8.svg";
export { ForwardRef as ReactComponent };